/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProviderBookingCreate } from '../models/ProviderBookingCreate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BookingsService {

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static bookingsCreate({
        requestBody,
    }: {
        requestBody: ProviderBookingCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/bookings/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
